import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 400 400",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMinYMin"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M388.821 204.341C388.821 191.64 387.695 179.583 385.766 167.847H204.1V240.353H308.116C303.454 264.146 289.788 284.242 269.532 297.907V346.137H331.588C367.921 312.537 388.821 263.021 388.821 204.341Z",
      fill: "#4285F4"
    }, null, -1),
    _createElementVNode("path", {
      d: "M204.099 392.92C256.188 392.92 299.756 375.557 331.588 346.137L269.532 297.907C252.169 309.482 230.144 316.556 204.099 316.556C153.779 316.556 111.176 282.634 95.9032 236.815H31.918V286.492C63.5891 349.513 128.7 392.92 204.099 392.92Z",
      fill: "#34A853"
    }, null, -1),
    _createElementVNode("path", {
      d: "M95.9039 236.816C91.8847 225.241 89.7947 212.862 89.7947 200C89.7947 187.139 92.0455 174.76 95.9039 163.185V113.508H31.9186C18.7357 139.552 11.1797 168.812 11.1797 200C11.1797 231.189 18.7357 260.449 31.9186 286.493L95.9039 236.816Z",
      fill: "#FBBC05"
    }, null, -1),
    _createElementVNode("path", {
      d: "M204.099 83.4444C232.555 83.4444 257.956 93.2512 278.052 112.382L333.034 57.4001C299.756 26.2114 256.188 7.08008 204.099 7.08008C128.7 7.08008 63.5891 50.4872 31.918 113.508L95.9032 163.185C111.176 117.366 153.779 83.4444 204.099 83.4444Z",
      fill: "#EA4335"
    }, null, -1)
  ])))
}
export default { render: render }